import PropertyShowTitle from './PropertyShowTitle';

export default PropertyShowTitle;
